import { createAsyncThunk } from "@reduxjs/toolkit";
import { setToken } from "lib/token";
import { loginAPI, fetchCurrentUserAPI } from "./api";
import { setLocalToken } from "lib/request";

// Action to login a user
export const login = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await loginAPI(credentials);

      if (response.success) {
        setToken(response.data.token);
        setLocalToken(response.data.token);
        return response.data.user;
      } else {
        throw new Error("Login failed");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Action to fetch the current logged-in user
export const fetchCurrentUser = createAsyncThunk(
  "auth/fetchCurrentUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCurrentUserAPI();
      if (response.data) {
        return response.data;
      } else {
        throw new Error("No user found");
      }
    } catch (error) {
      return rejectWithValue("Invalid or expired token");
    }
  }
);
